<template>
    <div :class="data.display? 'skill_submit_card_a': 'skill_submit_card_a_not_display'">
        <DocumentDialog v-model="showDialog" type='download' :document_access="document_access" :data=documentData @close="clickClose()" @cancel="clickCancel()" @confirm="clickConfirm()"></DocumentDialog>
        <div class="skill_submit_card_layout_div">
            <!--<form @submit.prevent="upload_data($event)">-->
            <form :action="url" method="post" enctype="multipart/form-data">
                <p class="skill_submit_card_title_p no_margin">{{ data.name }}</p>
                <p class="skill_submit_card_chapter_p no_margin"> 自评结果：{{ data.ch }}</p>
                <p class="skill_submit_card_chapter_p no_margin"> {{ data.caption }}</p>
                <p class="skill_submit_card_chapter_p no_margin"> 已上传佐证材料份数：{{ data.evi_exist_count }}</p>
                <input class="upload_input" type="file"
                    v-for="(index) in data.input_count" :key="index" :name="index">
                <input type="text" name="id" hidden :value="data.id">
                <button type="submit" class="submit" @click="submit_click(data.id)">{{data.evi_completed? '重新提交': '提交'}}</button>
            </form>
        </div>
        <div class="skill_submit_suggest_layout_idv">
            <p class="skill_submit_card_title_p no_margin">精选推荐</p>
            <button class="doc_btn"
               v-for="doc in data.docs"
               :key="doc"
               @click="openDocumentDialog(doc)"> {{ doc.name }}</button>
        </div>
    </div>
</template>
<script type="text/javascript">
import { mapState, mapActions  } from 'vuex'
import DocumentDialog from '@/components/common_components/dialog/document_dialog.vue'
import documentApi from '@/api/document/document.js'

export default {
    props: {
        data: {
            type: Object,
            require: true
        }
    },
    data() {
        return {
            showDialog: false,
            documentData: null,
            document_access: false,
        }
    },
    components: {
        DocumentDialog,
    },
    computed: {
        ...mapState({
            star: state => state.skill_submit.star,
            url: state => state.skill_submit.url
        })
    },
    methods: {
        ...mapActions({
            load_star: 'skill_submit/load_star',
            click_star: 'skill_submit/click_star',
            upload_data: 'skill_submit/upload_data',
            submit_click: 'skill_submit/set_skill_display'
        }),
        openDocumentDialog(doc) {
            this.showDialog = true;
            this.documentData = doc;
            console.log(doc)
            documentApi.get_document_access({'id': doc.id}).then((res) => {
                console.log(res)
                this.document_access = res.data.document_access
            })
        },
        clickCancel() {
        },
        clickConfirm() {
        },
        clickClose() {
            this.showDialog = false;
        }
        // submit_click: function (val) {
        //     val.path[1].parentNode.parentNode.style.display="none"
        // }
    },
    mounted: function () {
        // this.load_star(this.data)
    }

}
</script>
<style type="text/css" scoped>
.skill_submit_card_a {
    display: flex;
    border: 1px solid #eee;
    box-shadow: 0 1px 2px 0 #d2d2d2;
    padding: 11px 13px;
    margin-bottom: 32px;
}
.skill_submit_card_a_not_display {
    display: none;
    border: 1px solid #eee;
    box-shadow: 0 1px 2px 0 #d2d2d2;
    padding: 11px 13px;
    margin-bottom: 32px;
}

.skill_submit_card_a:hover {
    box-shadow: 0 2px 8px 0 #d2d2d2;
}

.skill_submit_card_img_layout_div {
    display: block;
    padding: 10px 13px 10px 0;
}
.upload_input {
    /*border-radius: 20px;*/
    font-size: 12px;
    box-shadow: 1px 1px 5px rgba(0,0,0,.1), 0 0 10px rgba(0,0,0,.12);
}

.skill_star_img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
}

.skill_submit_card_layout_div {
    display: inline-block;
    width: 66%;
    flex-direction: column;
    justify-content: space-between;
}
.skill_submit_suggest_layout_idv {
    display: inline-block;
    width: 33%;
    flex-direction: column;
    justify-content: space-between;
}

.skill_submit_card_title_p {
    font-size: 16px;
    color: #565656;
    max-height: 45px;
    overflow: hidden;
    word-break: break-word;
    text-overflow: ellipsis;
}

.skill_submit_card_chapter_p {
    font-size: 14px;
    color: #666;
}
.skill_submit_card_chapter_a {
    display: block;
    font-size: 14px;
}
.submit {
    padding: .100rem .10rem;
    color: #fff;
    margin: 10px;
    background: #66CCFF;
    border: 1px solid #59C0F0;
    width: 100px;
    font-size: 1rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.doc_btn {
    display: block;
    padding: .100rem .10rem;
    color: #12141d;
    margin: 10px;
    background: #e3f1ff;
    border: 1px solid #ede8f0;
    font-size: 1rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
/*.file input {*/
    /*position: absolute;*/
    /*font-size: 100px;*/
    /*right: 0;*/
    /*top: 0;*/
    /*opacity: 0;*/
/*}*/
/*.file:hover {*/
    /*background: #AADFFD;*/
    /*border-color: #78C3F3;*/
    /*color: #004974;*/
    /*text-decoration: none;*/
/*}*/
.no_margin {
    margin: 0;
}

</style>
